<template>
  <div>
    <div v-if="loading" class="center-loading">
      <img src="../../assets/loading-icon.gif" alt="loading icon" />
    </div>
    <div v-else>
      <oilgas2charts class="chart" :updateArgs="updateArgs" :options="chartOptions" ref="oilgas2"></oilgas2charts>
    </div>

    <div class="row">
      <caption>
        <p>The abatement potential is projected to increase over time to 684 MtCO₂e in 2030. In 2030, abatement measures could reduce emissions by 23% at break-even prices of $20 or below. However, in 2030, 37% of potential abatement is estimated to cost more than $50/tCO₂e, suggesting that achieving these reductions would be difficult without reducing the cost of abatement or improving the removal efficiency of available abatement measures.</p>
      </caption>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import drilldownInit from "highcharts/modules/drilldown";
import exportingInit from "highcharts/modules/exporting";
import stockInit from "highcharts/modules/stock";

//import { EventBus } from "@/event-bus.js";
//reduction potential for 2020 versus 2050
stockInit(Highcharts);
exportingInit(Highcharts);
drilldownInit(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: ".",
    thousandsSep: ","
  }
});

export default {
  data() {
    return {
      loading: true,
      updateArgs: [true, false, true],
      chartOptions: {
        chart: {
          type: "bar"
        },
        title: {
          text: "Total Reduction Potential (%)"
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: [2020, 2030, 2040, 2050]
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Percent Reduction Potential"
          }
        },
        legend: {
          reversed: true
        },
        tooltip: {
          headerFormat: "<b>{point.x}</b><br/>",
          pointFormat: "{series.name}: {point.y:,.0f}%"
        },
        plotOptions: {
          series: {
            stacking: "normal"
          }
        },
        series: [
          {
            name: "Residual Emissions",
            data: []
          },
          {
            name: "Technically Feasible",
            data: []
          },
          {
            name: "Reduction/no cost",
            data: []
          }
        ]
      }
    };
  },
  beforeCreate() {
    fetch("../includes/queries.cfc?method=getMACsPC&categoryId=7")
      .then(resp => resp.json())
      .then(resp => {
        for (var i = 0; i < 4; i++) {
          this.chartOptions.series[0].data.push(resp.DATA[i][9]);
          this.chartOptions.series[1].data.push(resp.DATA[i][8]);
          this.chartOptions.series[2].data.push(resp.DATA[i][7]);
        }
      })
      .catch(function(error) {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  props: {
    partsdata: {
      type: Array
    }
  },
  components: {
    oilgas2charts: Chart
  }
};
</script>
